import React from "react";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { Avatar, Box, Link, Stack, Typography } from "@mui/material";

function buildStatusLine(person) {
  const label = person?.status_label || "Quiet";
  const detail = person?.status_detail || "";
  return detail ? `${label} • ${detail}` : label;
}

export default function PersonHeader({ person, onBack, backLabel = "Back to Connections" }) {
  const statusLine = buildStatusLine(person);
  const description = person?.headline || person?.shared_focus_statement || "";

  return (
    <Stack spacing={2}>
      <Link
        component="button"
        underline="none"
        onClick={onBack}
        sx={{
          alignSelf: "flex-start",
          display: "inline-flex",
          alignItems: "center",
          gap: 0.6,
          color: "#17345d",
          fontWeight: 800,
          fontSize: 14,
        }}
      >
        <ArrowBackRoundedIcon sx={{ fontSize: 18 }} />
        {backLabel}
      </Link>

      <Box
        sx={{
          borderRadius: 4,
          border: "1px solid rgba(224, 231, 240, 0.92)",
          bgcolor: "#fff",
          boxShadow: "0 10px 24px rgba(15, 23, 42, 0.05)",
          px: { xs: 2, md: 3 },
          py: { xs: 2, md: 2.4 },
        }}
      >
        <Stack spacing={2.2}>
          <Stack direction="row" spacing={1.6} alignItems="center">
            <Avatar
              src={person?.avatar || ""}
              sx={{ width: 72, height: 72, bgcolor: "#edf3f8", color: "#17345d", fontWeight: 800 }}
            >
              {(person?.name || "T").slice(0, 1).toUpperCase()}
            </Avatar>
            <Stack spacing={0.5}>
              <Typography variant="h4" sx={{ fontSize: 34, fontWeight: 800, letterSpacing: -1.1 }}>
                {person?.name || "Person"}
              </Typography>
              <Typography variant="body1" sx={{ color: "#5f7085", fontWeight: 700 }}>
                {statusLine}
              </Typography>
              {description ? (
                <Typography variant="body2" sx={{ color: "#6f7f94", maxWidth: 560 }}>
                  {description}
                </Typography>
              ) : null}
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
}
